import { Alert, Box, CircularProgress, Container } from '@mui/material';
import { useEffect, useState } from 'react';
import AssessmentPublicationReplayClient, { AssessmentPublicationReplay } from '../apiClients/AssessmentPublicationReplayClient';
import AssessmentPublicationReplayPresentation from '../components/assessment/AssessmentPublicationReplayPresentation';

const AssessmentPublicationReplayPage = () => {
    const [replay, setReplay] = useState<AssessmentPublicationReplay | null>(null);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        const controller = new AbortController();
        new AssessmentPublicationReplayClient().Get(controller.signal)
            .then(result => { if (!controller.signal.aborted) setReplay(result); })
            .catch(() => { if (!controller.signal.aborted) setFailed(true); });
        return () => controller.abort();
    }, []);

    if (failed) return <Container maxWidth="md" sx={{ py: 4 }}><Alert severity="warning">Assessment publication replay is unavailable for this organization.</Alert></Container>;
    if (!replay) return <Box role="status" aria-label="Loading assessment publication replay" sx={{ minHeight: 300, display: 'grid', placeItems: 'center' }}><CircularProgress /></Box>;

    return <AssessmentPublicationReplayPresentation replay={replay} />;
};

export default AssessmentPublicationReplayPage;
